import { extendTheme } from '@chakra-ui/react';

export const theme = extendTheme({
  fonts: {
    body: `"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"`,
  },
  colors: {
    custom_orange: { 2: '#ec5e2a', 3: '#f9dbaf', 4: '#fdf3e6' },
    grayish: '#d0d5dd',
    error: { DEFAULT: '#fda29b', 600: '#ff3654' },
    warning: '#fdf3e6',
    custom_blue: { 1: '#2f384c', 2: '#3f458e', 3: '#d9dae8', 4: '#f8f9fc' },
    custom_gray: { 1: '#666666', 2: '#fafafa', 3: '#eaecf0', 4: '#e8e7e3' },
    custom_green: { 1: '#4b7b51', 3: '#abefc6', 4: '#ecfdf3' },
    inactive: { 1: '#b42318', 2: '#fecdca', 3: '#fef3f2' },
    pending: { 1: '#b93815', 2: '#f9dbaf', 3: '#fef6ee' },
    shiny_blue: { 1: '#175cd3', 2: '#b2ddff', 3: '#eff8ff' },
  },
});
